import { useState, useEffect, createContext } from 'react';
import PropTypes from 'prop-types';
import { Loader } from '../components/common/Loader';
import { db } from '../firebase';
import { collection, doc, getDocs } from 'firebase/firestore';

export const FeatureFlags = createContext({});

export const FeatureFlagsProvider = ({ children }) => {
   const [isLoading, setIsLoading] = useState(true);
   //set defaults for flags here
   const [featureFlags, setFeatureFlags] = useState({
    statements: {
      viewStatementUsers: [],
    }
   });

  useEffect(() => {
    const fetchFeatureFlags = async () => {
      try {
        const featureFlagsRef = doc(db, 'configuration', 'feature_flags');
        const clientPortalRef = collection(featureFlagsRef, 'client_portal');
        const snapshot = await getDocs(clientPortalRef);

        if(snapshot.empty) {
          //use default initialized in state
          return;
        }

        let featureFlagObject = {}
        
        snapshot.docs.forEach(doc => {
          featureFlagObject[doc.id] = doc.data();
        });
        setFeatureFlags(featureFlagObject);

      } catch (error) {
        console.error('Error fetching features:', error);
        setIsLoading(false)
      } finally {
        setIsLoading(false)
      }
    };

    fetchFeatureFlags();
  }, []);

   return (
     <FeatureFlags.Provider value={{ featureFlags }}>
       {isLoading ? <Loader /> : children}
     </FeatureFlags.Provider>
   );
};

FeatureFlagsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};